module.exports = __webpack_public_path__ + "static/img/banner.083cffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = hKcQ
// module chunks = 0